import React from "react";
import { FormattedMessage } from "react-intl";

import messages from "./messages";
import { IProps } from "./interfaces";

const Retry = ({ onClick }: IProps) => (
    <button className="button button--light" onClick={onClick}>
        <FormattedMessage {...messages.retry} />
    </button>
);

export default Retry;
